<!-- 支付宝身份验证弹出 -->
<template>
  <div class="certifBox">
    <div class="certif">
      <div class="_title">
        <span></span>
        <span><img @click.stop="hide()" src="../../assets/GuaB.png" alt=""></span>
      </div>
      <div class="_cont">
        <div class="auth-title" v-if="authType === 0">
          <p>
            <template v-if="!show_error">
              <i class="el-icon-loading"></i>
              请在<span class="red">{{ num }}</span>秒内完成认证... 
            </template>
            <template v-else>
              <span class="red">当前认证超时!</span>
            </template>
          </p>
        </div>
        <p ref="qrcodeRef" id="qrcode" class="_code" v-if="show"></p>
        <div class="button-box _code" v-else>
          <el-button type="primary" @click="showCretificat">重新认证</el-button>
          <el-button type="primary" :loading="loading" class="auth" @click="getAuthResult(true)">
            {{ loading ? '验证中...' : '已认证通过' }}
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2'
import { request } from "../../css/request.js";
import { Apis } from "../../css/Api.js";
export default {
  name:'ZFBcertif',
  props:{
    qrdata:{
      type:Object,
      required:true
    }
  },
  components: {QRCode},
  data(){
    return {
      qrcodeRef: null,
      authType:0,
      timer: null,
			interval: 1000,
      reason: '',
      num: 60,
      show: true,
      show_error: false,
      val: 0,
      loading: false
    }
  },
  created(){
    document.body.style.overflow = 'hidden'
  },
  mounted(){
    this.mainQrData = this.qrdata
    this.initTimer()
  },
  beforeDestroy() {
    this.clearTimer()
    document.body.style.overflow = ''
  },
  methods:{
    initTimer(url = '') {
      this.num = 60
      this.show_error = false
      this.show = true
      this.startTimer()
      if (url) {
        this.$nextTick(() => {
          this.$refs.qrcodeRef.innerHTML = "";
          this.qrcode(url)
        });
      } else {
        this.qrcode(this.mainQrData.certify_url)
      }
    },
    startTimer() {
			if (!this.timer) {
        this.timer = setInterval(() => {
          if (this.authType !== 0 || this.num <= this.val) {
            this.clearTimer()
            if (this.num <= this.val) {
              this.show = false
              this.show_error = true
            }
            return
          }
          this.num--
          this.getAuthResult()
        }, this.interval);
      }
		},
		clearTimer() {
			if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
		},
    showCretificat(){
			const data = {
				id_card:this.mainQrData.sendData.id_card,
				real_name:this.mainQrData.sendData.real_name,
				access_token:this.mainQrData.sendData.access_token,
				id_card_type:this.mainQrData.sendData.id_card_type,
			}
			request({
				method: 'post', 
				url: Apis.getAuthUrl,
				params:data
			}).then(res => {
				if(res.code == 0){
          this.mainQrData = res.data
          this.initTimer(res.data.certify_url)
				}else{
					this.$message.error(res.msg);
				}
			});
		},
		getAuthResult(flag) {
      if (flag) {
        this.loading = true
      }
			request({
				method: 'get', 
				url: Apis.queryAuth,
				params: {
          certify_id: this.mainQrData.certify_id,
          order_id: this.mainQrData.order_id,
          access_token: localStorage.getItem('access_token')
        }
			}).then(res => {
				if(res.code == 0){
          this.authType = res.data.authType
          if (res.data.authType === 1) {
            this.clearTimer()
            this.$message.success('认证成功')
            this.hide({
              flag: 1,
              msg: '认证成功'
            })
          } else {
            if (flag) {
              this.$message.error('认证验证未通过,请点击按钮重新验证');
            }
          }
          this.loading = false
				}
			})
		},
    hide(data){
      this.$emit('hide', data)
    },
    qrcode(qr){
      let qrcode = new QRCode('qrcode', {  
        width: 180,  // 二维码宽度 
        height: 180, // 二维码高度
        text: qr,
      })  
    },
    
  }
}
</script>

<style lang="less" scoped>
.certifBox{
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, .7);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999  ;
  .certif{
    position: relative;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    width: 500px;
    height: 663px;
    background: url('../../assets/certifBg.png')no-repeat;
    background-size: 100%;
    ._title{
      width: 100%;
      height: 30px;
      background: #fff;
      display: flex;
      justify-content: space-between;
      align-items: center;
      span{
        display: inline-block;
        width: 15px;
        height: 15px;
        margin-right: 10px;
        img{
          width: 100%;
          height: 100%;
          cursor: pointer;
        }
      }
    }
    ._cont{
      width: 100%;
      height: calc(100% - 30px);
      .auth-title{
        color: #fff;
        font-size: 18px;
        font-weight: bold;
        width: 100%;
        height: 50px;
        margin: 130px auto;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        i{
          font-size: 20px;
        }
        &.error{
          color: red;
          margin: 120px auto;
        }
      }
    }
    .red{
      color: red;
      font-size: 18px;
    }
    ._code{
      width: 190px;
      height: 190px;
      position: absolute;
      top: 200px;
      left: 50%;
      border-radius: 10px;
      transform: translateX(-51.3%);
      padding: 5px;
    }
    .button-box{
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .el-button{
        margin-left: 0;
      }
      .auth{
        margin-top: 20px;
      }
    }
  }
}
</style>